import controller from './compare-products.controller';
import templateBase from './templates/compare-products-base.view.html';

let CompareProductsComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    /*if (response.BY_FAVORITES.component == 'template_t1') {
        return templateT1;
    } else {*/
    return templateBase;
    //}
}

export default CompareProductsComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/compare-products/compare-products.component.js
 **/